export default function (value, fractionDigits = 2) {
  if (!value) {
    return '0'
  }
  return Number(value).toFixed(fractionDigits).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace('.', ',')
}
